import React from 'react';

import { Icon } from '@epoch-ui/components/Icon';

export const EmptyMultiSessionEventFeedback: React.FC = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-dashed tw-border-border-grey tw-bg-background tw-py-8">
      <div className="tw-space-y-4 tw-text-center tw-font-normal tw-leading-5 tw-text-muted-foreground">
        <Icon name="list" size={24} />
        <div className="tw-text-sm tw-font-normal tw-leading-4 tw-text-muted-foreground">
          <p className="tw-m-0">Add a session to start creating feedback questions</p>
        </div>
      </div>
    </div>
  );
};
